import {applyMiddleware, createStore} from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';


import rootReducers from '../reducers/index';


const appStore=(preloadState)=>{
    return createStore(rootReducers, preloadState, applyMiddleware(logger,thunk));
}


export default appStore;